import { Component } from '@angular/core'

@Component({
   selector: 'app-documents',
   standalone: true,
   imports: [],
   templateUrl: './documents.component.html',
   styles: ''
})
export class DocumentsComponent {

}
